import { ApiClient } from "client/base";
export class LanguageModelArtifactClient extends ApiClient {
    accountClient;
    constructor(base, accountClient) {
        super(base);
        this.accountClient = accountClient;
    }
    createArtifact(accountId, create) {
        return this.base.post(`account/${accountId}/artifacts`, create);
    }
    getArtifact(artifactId) {
        return this.base.get(`language_model_artifacts/${artifactId}`);
    }
    getArtifacts(filter) {
        const searchParams = new URLSearchParams("");
        for (const [key, value] of Object.entries(filter)) {
            searchParams.append(key, String(value));
        }
        return this.base.get(`language_model_artifacts?${searchParams.toString()}`);
    }
    getArtifactsThin(filter, include) {
        const searchParams = new URLSearchParams("");
        for (const [key, value] of Object.entries(filter)) {
            searchParams.append(key, String(value));
        }
        for (const inc of include) {
            searchParams.append("i", inc);
        }
        return this.base.get(`language_model_artifacts?${searchParams.toString()}`);
    }
    getArtifactsWithDetails(accountId, folderId, filter) {
        return this.accountClient
            .getCustomerClientFactory(accountId)
            .then((ccf) => ccf.getCompletionClient().getArtifactsWithDetails({ ...filter, folder_id: folderId }));
    }
    updateArtifact(artifact, update) {
        return this.base.patch(`language_model_artifacts/${artifact.id}`, update);
    }
    deleteArtifact(artifactId) {
        return this.base.delete(`language_model_artifacts/${artifactId}`);
    }
    createArtifactUploadURL(artifactId, filename) {
        return this.base.post(`language_model_artifacts/${artifactId}/uploads`, { filename });
    }
    _getCustomerClientFactory(artifact) {
        return this.accountClient.getCustomerClientFactory(artifact.account_id);
    }
    uploadArtifactAsset(artifact, file) {
        return this.createArtifactUploadURL(artifact.id, file.name).then((upload) => this._getCustomerClientFactory(artifact).then((ccf) => ccf.getDatasetClient().uploadDataset(file, upload)));
    }
    addFineTuningData(artifact, records) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().addFineTuningData(artifact.id, records));
    }
    addDocumentUrls(artifact, urls) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().addDocumentUrls(artifact.id, urls));
    }
    createFineTunedModel(artifact, create) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().createFineTunedModel({ fine_tuning_data_id: artifact.id, ...create }));
    }
    createTrainingDataset(artifact, data) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().createFineTuningDataset(artifact.id, data));
    }
    deleteFineTuningDataset(artifact) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().deleteFineTuningDataset(artifact.id));
    }
    getFineTunedModel(artifact) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().getFineTunedModel(artifact.id));
    }
    cancelFineTuning(artifact) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().cancelFineTuning(artifact.id));
    }
    getFineTuningData(artifact) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().getFineTuningData(artifact.id));
    }
    reindexCorpus(artifact, options = {}) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().reindexCorpus(artifact.id, options));
    }
    getCorpusDocumentList(artifact) {
        return this._getCustomerClientFactory(artifact).then((ccf) => ccf.getCompletionClient().getCorpusDocumentList(artifact.id));
    }
}
